var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.5,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(49.05 -144.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "M-2.666,357H-8.573a11.729,11.729,0,0,0-.227,2.3,11.646,11.646,0,0,0,.725,4.063h5.364A36.617,36.617,0,0,1-2.666,357Z",
    transform: "translate(-37.786 -207.294)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    d: "M24.1,512a12,12,0,0,0,5.791,4.761A24.79,24.79,0,0,1,28.634,512Z",
    transform: "translate(-68.864 -359.289)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_326_",
    d: "M151.834,184.672a11.536,11.536,0,0,0-1.318-.072,12.66,12.66,0,0,0-1.6.105,43.387,43.387,0,0,0-1.716,7.224h6.853A37.334,37.334,0,0,0,151.834,184.672Z",
    transform: "translate(-191.377 -37.88)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_327_",
    d: "M280.049,203.171H285.3a11.969,11.969,0,0,0-7.1-6.671,39.74,39.74,0,0,1,1.838,6.621A.162.162,0,0,1,280.049,203.171Z",
    transform: "translate(-321.219 -49.121)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    d: "M7.5,204.3h5.492a47.563,47.563,0,0,1,1.428-6.6A11.973,11.973,0,0,0,7.5,204.3Z",
    transform: "translate(-53.183 -50.255)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_359_",
    d: "M323.3,357h-5.6a29.665,29.665,0,0,1,.116,6.167l-.017.2h5a11.764,11.764,0,0,0,.5-6.366Z",
    transform: "translate(-358.533 -207.294)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_360_",
    d: "M148.411,517.458a12.2,12.2,0,0,0,1.633.111,12.559,12.559,0,0,0,1.589-.105A18.625,18.625,0,0,0,153.681,512H146.7A20.962,20.962,0,0,0,148.411,517.458Z",
    transform: "translate(-190.926 -359.289)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_362_",
    d: "M139.293,357a34.664,34.664,0,0,0-.044,6.366h7.623a27.511,27.511,0,0,0-.094-6.366Z",
    transform: "translate(-183.793 -207.294)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_363_",
    d: "M287.3,516.722A12.01,12.01,0,0,0,292.985,512h-4.224A21.487,21.487,0,0,1,287.3,516.722Z",
    transform: "translate(-329.815 -359.289)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_378_",
    d: "M-35.142,146.842A7.948,7.948,0,0,0-40.8,144.5a7.941,7.941,0,0,0-5.654,2.342A7.939,7.939,0,0,0-48.8,152.5a7.94,7.94,0,0,0,2.346,5.658A7.954,7.954,0,0,0-40.8,160.5a7.941,7.941,0,0,0,5.654-2.342A7.94,7.94,0,0,0-32.8,152.5,7.949,7.949,0,0,0-35.142,146.842Zm.585,3.089h-2.968c0-.009,0-.019-.006-.028a22.808,22.808,0,0,0-1.038-3.765A6.781,6.781,0,0,1-34.558,149.931Zm-7.146-4.109a6.6,6.6,0,0,1,.9-.06,7.225,7.225,0,0,1,.744.041,21.11,21.11,0,0,1,1.254,4.128h-3.872A24.624,24.624,0,0,1-41.7,145.822Zm-5.845,6.678a6.714,6.714,0,0,1,.128-1.31h3.337a20.666,20.666,0,0,0-.028,3.621h-3.027A6.663,6.663,0,0,1-47.549,152.5Zm1.029,3.57h2.565a13.947,13.947,0,0,0,.71,2.708A6.783,6.783,0,0,1-46.52,156.07Zm2.583-6.139h-3.1a6.784,6.784,0,0,1,3.909-3.756A27.205,27.205,0,0,0-43.937,149.931Zm4.038,9.247a7.046,7.046,0,0,1-.9.06,6.882,6.882,0,0,1-.923-.063,11.853,11.853,0,0,1-.963-3.1h3.944A10.827,10.827,0,0,1-39.9,159.178Zm1.354-4.367h-4.306a19.846,19.846,0,0,1,.025-3.621H-38.6A15.75,15.75,0,0,1-38.545,154.811Zm.256,3.945a12.345,12.345,0,0,0,.826-2.686h2.386A6.781,6.781,0,0,1-38.289,158.756Zm1.007-3.945.009-.113a16.986,16.986,0,0,0-.066-3.507h3.162a6.714,6.714,0,0,1,.128,1.31,6.663,6.663,0,0,1-.41,2.311Z",
    transform: "translate(0)",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.4abe8be4f390c4ac16612b42f8970e79.svg";
export { ForwardRef as ReactComponent };